import { createElement } from '@syncfusion/ej2-base';
/**
 * Selection overlay to visually indicate a selection over a target content element.
 * It draws an absolutely positioned box inside the editor root, without affecting layout.
 */
export class SelectionOverlay {
    constructor(manager) {
        this.overlayEl = null;
        this.selectionOverlayInfo = null;
        this.parent = manager;
    }
    show(targetId) {
        const el = this.ensureOverlay();
        this.positionTo(targetId);
        el.style.display = 'block';
    }
    hide() {
        if (this.overlayEl) {
            this.overlayEl.style.display = 'none';
        }
    }
    reposition() {
        if (!this.overlayEl || this.overlayEl.style.display === 'none') {
            return;
        }
        const targetId = this.overlayEl.getAttribute('data-target-id');
        this.positionTo(targetId);
    }
    destroy() {
        if (this.overlayEl && this.overlayEl.parentElement) {
            this.overlayEl.parentElement.removeChild(this.overlayEl);
        }
        this.overlayEl = null;
    }
    clearSelectionOverlay() {
        const dragIcon = this.parent.floatingIconAction.floatingIconContainer.querySelector('.e-block-drag-icon');
        if (dragIcon) {
            dragIcon.classList.remove('e-drag-icon-selected');
        }
        this.selectionOverlayInfo = null;
        if (this.parent.selectionOverlay) {
            this.parent.selectionOverlay.hide();
        }
    }
    ensureOverlay() {
        if (this.overlayEl && this.overlayEl.parentElement) {
            return this.overlayEl;
        }
        const overlay = createElement('div', {
            className: 'e-be-selection-overlay'
        });
        overlay.id = this.parent.rootEditorElement.id + '_softSelOverlay';
        overlay.style.display = 'none';
        this.parent.rootEditorElement.appendChild(overlay);
        this.overlayEl = overlay;
        return overlay;
    }
    positionTo(targetId) {
        const isMultipleBlockSeleceted = this.parent.editorMethods.getSelectedBlocks() && this.parent.editorMethods.getSelectedBlocks().length > 1;
        if (this.overlayEl && !isMultipleBlockSeleceted) {
            const targetBlock = this.parent.getBlockElementById(targetId);
            if (targetBlock) {
                const rootRect = this.parent.rootEditorElement.getBoundingClientRect();
                const targetRect = targetBlock.getBoundingClientRect();
                const isRtl = this.parent.rootEditorElement.classList.contains('e-rtl');
                const styles = getComputedStyle(targetBlock);
                const paddingLeft = styles.getPropertyValue('padding-left');
                const marginLeft = styles.getPropertyValue('margin-left');
                const paddingRight = styles.getPropertyValue('padding-right');
                const marginRight = styles.getPropertyValue('margin-right');
                const left = (targetRect.left - rootRect.left + parseInt(paddingLeft, 10) - parseInt(marginLeft, 10) +
                    (!isRtl ? -3 : parseInt(paddingRight, 10) - 6.5 + parseInt(marginRight, 10))) +
                    this.parent.rootEditorElement.scrollLeft;
                const top = (targetRect.top - rootRect.top) + this.parent.rootEditorElement.scrollTop;
                this.overlayEl.style.left = left + 'px';
                this.overlayEl.style.top = top + 'px';
                this.overlayEl.style.width = targetRect.width - 50 - (parseInt(targetBlock.style.getPropertyValue('--block-indent'), 10)) + 'px';
                this.overlayEl.style.height = targetRect.height + 'px';
                this.overlayEl.setAttribute('data-target-id', targetId);
            }
        }
    }
}
